import * as React from 'react'

const VerticalLineVG: React.FC = () => (
  <svg width="1" height="36" viewBox="0 0 1 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line
      x1="0.5"
      y1="0.998291"
      x2="0.499998"
      y2="35.9983"
      stroke="#AEAEB8"
      strokeDasharray="4 4"
    />
  </svg>
)

export default VerticalLineVG
